<template>
    <div class="box_content">
        <div class="table-responsive table_bordered">
            <table class="table mb-0">
                <thead>
                    <tr>
                        <th class="ps-3">Produto</th>
                        <th class="ps-3">Valor</th>
                        <th class="ps-3"></th>
                    </tr>
                </thead>
                <tbody v-if="bumps.length">
                    <tr v-for="(bump, key) in bumps" :key="key">
                        <td >
                            {{ bump.title }}
                        </td>
                        <td>
                            {{ globalStore.formatMoney(bump.price)}}
                        </td>
                        <td class="actions">
                            <button @click="editOrderBump(bump.id)" type="button" class="icon_buttons icon_view">
                                 <font-awesome-icon icon="fas fa-pen-to-square" />
                            </button>
                            <button @click="openPopup(bump.id)" type="button" class="icon_buttons icon_view">
                                <font-awesome-icon icon="fa-solid fa-trash-can" />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <h6 v-if="!bumps.length" class="text-center p-4 mb-0 divisor_bottom">Nenhum resultado encontrado</h6>
        </div>
        <div style="text-align:center;" class="p-4">
            <BaseButton @click="createOrderBump()" class="btn-success btn-lg">
                Adicionar
            </BaseButton>
        </div>
    </div>
    <router-view></router-view>
    <BasePopup v-if="confirmAction" closeType="stayOnPage" width="400" @clickToClose="clickToClose">
        <div class="confirm_action">
                <div class="popup ">
                    <p class="title">Atenção</p>
                    <p class="text">Deseja remover este order bump?</p>
                    <h6>Escreva a palavra "EXCLUIR" para confirmar.</h6>
                    <BaseInput
                        label=''
                        type="text"
                        id="excludeTextConfirm"
                        v-model="excludeTextConfirm"
                        :page="route.name"
                        class="col-12 mb-3"
                    />
                    <baseButton @click="clickToClose" style="width:110px" class="btn-secondary me-2">Cancelar</baseButton>
                    <baseButton @click="deleteOrderBump" style="width:150px" class="btn-success ms-2" :disabled="isLoading ? true : excludeTextConfirm == 'EXCLUIR' || excludeTextConfirm == 'excluir'  ? false : true">Sim, remover</baseButton>
                </div>
            </div> 
    </BasePopup>
</template>

<script setup>
import { computed, shallowRef,ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter} from 'vue-router'
import { useProductStore } from "@/stores/products";
import { useGlobalStore } from '@/stores/global';

const productStore = useProductStore();
const { bumps }  = storeToRefs(productStore); 
const globalStore = useGlobalStore();

const route = useRoute();
const router = useRouter();

const product_id = computed (function () {
    return route.params.id;
});

let orderBumpToDelete = null;
let isDeleting = false;
const confirmAction = shallowRef(null);
const excludeTextConfirm = ref(null);
const isLoading = ref(false);

function editOrderBump(id){
    globalStore.loader('show')
    productStore.tryOrderBump(id).then( function(success){
        if(success){
            router.push('/products/' + product_id.value + '/bump/' + id)
        }
        globalStore.loader('hide');
    })
}

function createOrderBump(){
    router.push('/products/' + product_id.value + '/bump/new')
}
async function deleteOrderBump(){
    if(!isDeleting && !isLoading.value && orderBumpToDelete && excludeTextConfirm.value == 'EXCLUIR' || excludeTextConfirm.value == 'excluir') {
        isLoading.value = true;
        globalStore.loader('show');
        await productStore.tryDeleteOrderBump(orderBumpToDelete).then(function(success) {
            isDeleting = false;
            if(success){
                useGlobalStore().successMessage('Order bump removido com sucesso');

                productStore.tryOrdersBumps().then(function() {
                    globalStore.loader('hide');
                    isDeleting = false;
                    router.push('/products/' + product_id.value + '/bump')
                });
                isLoading.value = false;
                confirmAction.value = null;
            }else {
                globalStore.loader('hide');
                isLoading.value = false;
                isDeleting = false;
            }
            excludeTextConfirm.value = null;
        }); 
    }
}

function openPopup(id) {
    orderBumpToDelete = id
    confirmAction.value = true
    excludeTextConfirm.value = null;
}

function clickToClose() {
    confirmAction.value = null;
}
</script>

<style scoped>

.table_bordered {
    background: #fff;
    border-radius: 8px;
}

thead {
    background: #fff;
    color: #595959;
}

tbody{
    border-bottom: 1px #ddd solid ;
}

tbody td {
    padding: 12px 16px;
    vertical-align: middle;
    color: #595959;
}

tbody tr:last-of-type {
    border-bottom: 0px solid #fff !important;
}

tbody tr:hover {
    background: #f3f3f3 !important;
}
</style>